module.exports = __webpack_public_path__ + "img/mi-star.301bd130.svg";